<template>
    <li>
        <div class="title"><span>オンライン/WEB</span></div>
        <div class="detail">
            <p><a :href="$store.state.register.form.web_url" class="md_text-link" target="_blank"><span>{{ $store.state.register.form.web_url }}</span></a></p>
        </div>
    </li>
</template>